<template>
  <v-col cols="12">
    <!-- Autocomplete -->
    <v-autocomplete 
      label="Receptores de Notificação" 
      persistent-hint 
      hint="Selecione até 5 receptores para notificações do WhatsApp"
      v-model="localSelected"
      :items="notificationReceptorsList" 
      item-text="text" 
      item-value="id"
      multiple
      chips
      deletable-chips
      small-chips
      :disabled="isLoading"
      :rules="[v => !v || v.length <= 5 || 'Máximo de 5 receptores permitidos']"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip
          v-if="index < 5"
          small
          close
          color="primary"
          outlined
          @click:close="removeReceptor(item.id)"
        >
          <v-icon left x-small>mdi-account</v-icon>
          {{ item.name }}
        </v-chip>
        <span
          v-if="index === 5"
          class="grey--text text-caption ml-2"
        >
          (+{{ localSelected.length - 5 }} outros)
        </span>
      </template>

      <template v-slot:prepend-item>
        <v-list-item v-if="localSelected.length > 0" class="grey lighten-4">
          <v-list-item-content>
            <v-list-item-subtitle class="text-caption">
              {{ localSelected.length }} de 5 receptores selecionados
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn 
              x-small 
              text 
              color="error"
              @click="clearAll"
            >
              Limpar Todos
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="localSelected.length > 0"></v-divider>
      </template>
    </v-autocomplete>

    <!-- Mensagem de erro -->
    <v-row v-if="localSelected.length > 5" style="margin-top: -15px; margin-left: 12px;">
      <span class="helper-text" style="color: red;">
        Você selecionou {{ localSelected.length }} receptores. O máximo permitido é 5.
      </span>
    </v-row>

    <!-- Lista de receptores -->
    <v-card v-if="localSelected.length > 0" outlined class="mt-4">
      <v-card-title class="subtitle-2 grey lighten-4">
        <v-icon left small>mdi-account-multiple</v-icon>
        Receptores Selecionados ({{ localSelected.length }}/5)
      </v-card-title>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item v-for="receptorId in localSelected" :key="receptorId">
          <v-list-item-avatar>
            <v-icon color="primary">mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ getReceptorById(receptorId) ? getReceptorById(receptorId).name : 'Receptor não encontrado' }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ getReceptorAlertsCount(receptorId) }} tipos de alertas configurados
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="flex-row">
            <!-- Botão de configuração -->
            <v-btn
              icon
              small
              color="primary"
              @click="emitConfig(receptorId)"
              :disabled="isLoading"
              class="mr-1"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
            <!-- Botão de remover -->
            <v-btn
              icon
              small
              color="error"
              @click="removeReceptor(receptorId)"
              :disabled="isLoading"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- Informação quando nenhum receptor está selecionado -->
    <v-alert v-if="localSelected.length === 0" type="info" text dense class="mt-4">
      Selecione receptores acima para configurar notificações personalizadas
    </v-alert>

    <v-divider></v-divider>
    <div style="padding: 10px; display: flex; justify-content: end;">
      <v-btn 
        text 
        :loading="savingConfigsLoading" 
        @click="emitSave" 
        :disabled="localSelected.length > 5"
      >
        <v-icon left>mdi-content-save</v-icon>
        Salvar Receptores
      </v-btn>
    </div>
  </v-col>
</template>

<script>
export default {
  name: "NotificationReceptors",
  props: {
    value: { type: Array, default: () => [] },
    notificationReceptorsList: { type: Array, required: true },
    isLoading: { type: Boolean, default: false },
    savingConfigsLoading: { type: Boolean, default: false },
    getReceptorById: { type: Function, required: true },
    getReceptorAlertsCount: { type: Function, required: true }
  },
  data() {
    return {
      localSelected: this.value
    };
  },
  watch: {
    localSelected(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    removeReceptor(id) {
      this.localSelected = this.localSelected.filter(r => r !== id);
    },
    clearAll() {
      this.localSelected = [];
    },
    emitSave() {
      this.$emit('save');
    },
    emitConfig(receptorId) {
      this.$emit('config', receptorId);
    }
  }
};
</script>
